/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Layout, message } from 'antd';
import { Link } from 'react-router';
import { getAccountInfo } from '@store/modules/account_info';
import local from '@util/local';
import Siderbar from './comm/Siderbar';
import MyHeader from './comm/Header';
import Home from './home/Index';

const { Content, Sider, Header } = Layout;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.current = 1;
  }

  componentDidMount() {
    this.props.dispatch(getAccountInfo());
  }

  logout = () => {
    const { router } = this.props;
    local.clearUser();
    message.info('您已退出系统！');
    router.push('/login');
  };

  itemRender = (route, params, routes, paths) => {
    if (routes.indexOf(route) === 0) {
      // 首页
      return (
        <Link to={`/${paths.join('/')}`}>
          <Icon type="home" />
          {route.breadcrumbName}
        </Link>
      );
    }
    if (routes.indexOf(route) === routes.length - 1) {
      // 最后一页
      return <span>{route.breadcrumbName}</span>;
    }
    return <Link to={`/${paths.join('/')}`}>{route.breadcrumbName}</Link>;
  };

  render() {
    const { routes, params } = this.props;
    const loginUser = local.getUser();
    const { domain } = document;

    const Page = this.props.children ? this.props.children : <Home {...this.props} />;
    return (
      <Layout style={{ height: '100%' }}>
        <Layout>
          <Sider>
            <Siderbar {...this.props} />
          </Sider>

          <Layout>
            <Header style={{ background: '#fff', padding: 0 }}>
              <MyHeader {...this.props} />
            </Header>
            <Content
              style={{
                padding: 15,
                minWidth: 1040,
                paddingBottom: 0,
                background: '#ececec',
                height: '100%',
              }}
              id="boxbox"
              className="localContent"
            >
              {Page}
            </Content>
          </Layout>
        </Layout>
        )
        {/* <Layout>
                    <Header style={{ zIndex: "20", background: '#fff', paddingLeft:20, paddingRight:20, position: "fixed", width: "100%" }} >
                        <Row type="flex" align="middle">
                            <Col span={14}>
                                <Breadcrumb routes={routes} params={params} itemRender={this.itemRender}/>
                            </Col>
                            <Col span={10} style={{textAlign:'right'}}>
                                <span style={{paddingRight:10 }}>Hi, </span>
                                <a style={{fontSize:20}}>{loginUser.name}</a>
                                <a onClick={this.logout}><Icon type="logout" style={{fontSize:20, marginLeft:10}} /></a>
                            </Col>
                        </Row>
                    </Header>
                    <Content style={{ padding: 15,minWidth: 1040,paddingBottom:0 }} id="boxbox" ref="boxbox" className="localContent">{ this.props.children }</Content>
                </Layout> */}
      </Layout>
    );
  }
}

export default connect(state => ({
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/Index.js